import type { Chat } from "@ch/generated";
import type { IAppChatState } from "./reducer";
import chatActionTypes from "./types";

export const readStoreChatMessage = (payload: Chat) => ({
  type: chatActionTypes.READ_CHAT,
  payload,
});

export const addUnreadChat = (payload: Chat) => ({
  type: chatActionTypes.ADD_UNREAD_CHAT,
  payload: { unreadMessages: [payload] },
});

export const updateAppChatState = (payload: IAppChatState) => ({
  type: chatActionTypes.UPDATE_APP_CHAT_STATE,
  payload,
});

export const addCoachIdsWithActiveUserSubscription = (
  payload: IAppChatState,
) => ({
  type: chatActionTypes.ADD_COACH_IDS_WITH_ACTIVE_USER_SUBSCRIPTION,
  payload,
});
